// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1vwNd","newExpiryDate":"styles_newExpiryDate__1TwVc","footer":"styles_footer__3rM1B"};